import { createApp } from "vue";
import WidgetApp from "./WidgetApp.vue";
import vuetify from "./plugins/vuetify";
import { createRouter, createWebHistory } from "vue-router";
import { VueShowdownPlugin, showdown } from "vue-showdown";
import ConversationWidget from "./components/ConversationWidget.vue";
import Vue3Lottie from "vue3-lottie";
import "vue3-lottie/dist/style.css";

showdown.extension('targetlink', function() {
  return [{
    type: 'html',
    regex: /(<a [^>]+?)(>.*<\/a>)/g,
    replace: '$1 target="_blank"$2'
  }];
});

const routes = [
  {
    path: "/widget/conversation",
    name: "ConversationWidget",
    component: ConversationWidget,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  //console.log("Navigating from", from, "to", to);
  next();
});

//console.log("WidgetApp");
createApp(WidgetApp)
  .use(router)
  .use(vuetify)
  .use(Vue3Lottie)
  .use(VueShowdownPlugin)
  .mount("#widget-app");
